
import React, { useState, useEffect } from "react";
import Header from '../../common/header'
import Footer from '../../common/footer'
import SvgIcon from '../../common/svg-icon/svg-icon'
import { Button, Breadcrumb } from 'semantic-ui-react'
import { NewInviteUser } from '../../common/newInviteUser';
import './index.scss'
import SweetAlerts from "../../../components/common/sweetalerts/sweetalert";
import CareesImg from '../../../assets/images/new-images/careers.jpg';
import SEO from '../../../components/seo/SEO';
const CareersView = () => {

  const [showMessage, setshowMessage] = useState(false)

  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'ecosystem', content: 'Careers', link: false },
  ]

  const apply_now = () => {
    setshowMessage(true)
  }

  const handleProductCloseAlert = () => {
    setshowMessage(false)
  }

  return (
    <>
      <SEO key="careers-seo"
        robots="index, follow"
        canonicalUrl="/careers"
        alternateLink="/careers"
        pageType={'careers'}

      />
      <Header />
      <div className='career-view'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>
        <section className='banner-section'>
          <div className='mappes-container'>
            <div className='banner-card'>
              <img className='banner-img' src={CareesImg} alt='' />
              <div className='overlay-div'>
                <h2>Be a part of Mappes Team!</h2>
                <p>We’re looking for passionate people to join us on our mission. We value flat hierarchies, clear communication and full ownership and responsibilty.</p>
              </div>
            </div>
          </div>
        </section>
        <section className='careerslist-section'>
          <div className='mappes-container'>
            <div className='careerslist'>
              {/* <div className='careerslist-item'>
                <div className='careerslist-item-left'>
                  <h3>React Developer</h3>
                  <p>We’re looking for mid-level React Developer to join our team!</p>
                  <div className='tags'>
                    <Button>Remote</Button>
                    <Button>Full time</Button>
                  </div>
                </div>
                <div className='careerslist-item-right'>
                  <Button basic>Apply Now!</Button>
                </div>
              </div> */}
              <div className='careerslist-item'>
                <div className='careerslist-item-left'>
                  <h3>Business Development Manager                  </h3>
                  <p>Experienced business development professional (5 - 10 years) required to drive sales of advanced equipment and materials across high-growth sectors <br /> such as solar, semiconductors, green hydrogen, and lithium-ion battery manufacturing.</p>
                  <div className='tags'>
                    <Button>On-Site</Button>
                    <Button>Full time</Button>
                  </div>
                </div>
                <div className='careerslist-item-right'>
                  <Button basic onClick={() => apply_now()}>Apply Now!</Button>
                </div>
              </div>
              <div className='careerslist-item'>
                <div className='careerslist-item-left'>
                  <h3>Service Engineer                  </h3>
                  <p>Field service engineer with 5- 10 years of experience in installation, commissioning, and after-sales support of high-tech equipment, <br /> requiring extensive travel across India.</p>
                  <div className='tags'>
                    <Button>Hybrid</Button>
                    <Button>Part-Time</Button>
                  </div>
                </div>
                <div className='careerslist-item-right'>
                  <Button basic onClick={() => apply_now()}>Apply Now!</Button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className='mappessubcribe-section'>
          <div className='mappes-container'>
            <div className='mappessubcribe-card'>
              <div className='mappessubcribe-row'>
                <h2>Interested? Reach out to us <br />  at <a href="emailto:careers@mappes.io" className=" ">careers@mappes.io</a> with your CV.</h2>
                <NewInviteUser />
              </div>
            </div>
          </div>
        </section>

        {showMessage && <SweetAlerts type={'S'} title={''} message={`Please share your CV with Ankit Singhal at <a href="mailto:ankit.singhal@mappes.io" target="_blank">ankit.singhal@mappes.io.</a>`} closeAlert={handleProductCloseAlert} html={true}> </SweetAlerts>}
      </div>
      <Footer />
    </>
  )
}

export default CareersView